import React from 'react';

import { ButtonLoginError } from 'js/app/components/main/Login/components/ButtonLoginError';
import { Loader } from 'js/components/common/Loader';
import { ManagedPopup } from 'js/components/common/Popup';
import { WebContentInner } from 'js/components/system/WebContent';

import { DATE_POSITION_LENGTH } from 'js/app/components/main/Login/constants';
import { useGetServerTime } from 'js/app/hooks/useServerTime';
import { useOnClose } from 'js/components/common/PopupManager/hooks';
import * as helpers from 'js/components/system/WebContent/helpers';
import * as hooks from 'js/components/system/WebContent/hooks';
import { useTranslations } from 'js/hooks/i18n';
import { useDataFetch } from 'js/hooks/useDataFetch';
import { useFormatter } from 'js/hooks/useFormatter';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';
import { get } from 'js/utils/fetch.util';

import style from 'js/app/components/main/Login/Login.scss';

export const parseErrorArticle = (rawContent = '', errorMessage = '', translate, date, getTimeLong, parseImsDate, getServerTime, expirationDate) => {
    const dateObj = parseImsDate(
        expirationDate
        || errorMessage.substr(errorMessage.length - DATE_POSITION_LENGTH, DATE_POSITION_LENGTH)
    );
    const currentDate = new Date();
    const formattedTime = !isNaN(dateObj.getTime())
        ? `${dateObj.toDateString()} @ ${getTimeLong(getServerTime(dateObj), 'en_GB')}`
        : translate('no_date');

    return currentDate > dateObj
        ? rawContent
            .replace(/\[in-start][^[]+\[in-end]/gi, '')
            .replace(/\[[^\]]+]/gi, '')
        : rawContent
            .replace(/\[out-start][^[]+\[out-end]/gi, '')
            .replace(/\[[^\]]+]/gi, '')
            .replace('***', formattedTime);
};

export const LoginExtendedErrorPopup = ({ id, articleId, messageToParse, title, onlyArticle, expirationDate, ...other }) => {
    const { date, getTimeLong, parseImsDate } = useFormatter();
    const getServerTime = useGetServerTime();
    const onClosePopup = useOnClose(id);
    const webContentUrl = hooks.useWebContentUrl({ webContentId: articleId, url: null });
    const translate = useTranslations('playtech.mobile.system.extendedloginerror.');
    const [{ isLoading, data: currentContent }, refetch] = useDataFetch({
        fetch: get,
        params: webContentUrl,
        initialIsLoading: false,
        shouldFetch: helpers.shouldFetch
    });

    useUpdateEffect(() => {
        refetch(webContentUrl);
    }, [refetch, webContentUrl]);

    const parsedArticle = currentContent
        ? parseErrorArticle(
            currentContent,
            messageToParse,
            translate,
            date,
            getTimeLong,
            parseImsDate,
            getServerTime,
            expirationDate
        )
        : null;

    return (
        <ManagedPopup
            onClose={onClosePopup}
            className={style.extendedErrorPopup}
            {...other}
        >
            {isLoading &&
                <Loader />
            }

            {parsedArticle && (
                <>
                    {title && !onlyArticle && <div className={style.extendedErrorTitle}>{title}</div>}

                    <WebContentInner content={parsedArticle} />

                    {!onlyArticle && (
                        <ButtonLoginError
                            view="secondary"
                            size="medium"
                            className={style.extendedErrorButton}
                            onClick={onClosePopup}
                        >
                            {translate('ok')}
                        </ButtonLoginError>
                    )}
                </>
            )}
        </ManagedPopup>
    );
};
